import ct from "class-types.macro";
import React, { useEffect, useState } from "react";
import Button from "~/common/Buttons";
import Icon from "~/common/Icons/Critical";
import setWindowLocationHref from "~/common/navigation/setWindowLocationHref";
import { addParamToUrl } from "../Sidebar/FilterUrlHelpers";

interface Props {
  submissionUrl: string;
}

export default function NewItemsShopAllProducts({ submissionUrl }: Props) {
  const [currentUrl, setCurrentUrl] = useState("");
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    setCurrentUrl(submissionUrl + window.location.search);
  }, [submissionUrl]);

  const handleSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();

    if (searchValue.trim().length > 0) {
      const updatedUrl = addParamToUrl(currentUrl, "withinval", searchValue);
      setWindowLocationHref(updatedUrl);
    }
  };

  return (
    <div className={ct("clear-both", "mt-16", "text-center")}>
      <p className={ct("font-semibold", "text-3xl", "mb-4")}>
        Shop All New Products
      </p>
      <form
        className={ct(
          "rounded",
          "flex",
          "flex-row",
          "h-12",
          "my-0",
          "mx-auto",
          "max-w-xl",
          "shadow",
          "md:w-3/4"
        )}
        action={submissionUrl}
        method="get"
        onSubmit={handleSubmit}
      >
        <input
          className={ct(
            "bg-white",
            "border-gray-100",
            "focus:border-blue-400",
            "rounded",
            "rounded-r-none",
            "border-solid",
            "border",
            "box-border",
            "h-12",
            "pl-4",
            "w-full"
          )}
          placeholder="Search new items..."
          aria-label="Search New Products: type a search term and hit enter"
          value={searchValue}
          onChange={(event) => {
            setSearchValue(event.target.value);
          }}
        />
        <Button
          type="submit"
          color="blue"
          size="custom"
          className={ct("rounded", "rounded-l-none", "h-12", "px-4")}
          value="Search"
        >
          <Icon
            className="fill-current h-6 text-white w-4"
            height="1rem"
            width="1rem"
            name="search"
            aria-hidden="true"
          />
        </Button>
      </form>
    </div>
  );
}
